query searchProductsSchemaForFamilyNg(
  $baseSiteId: BaseSiteId!
  $factFinderChannel: FactFinderChannel!
  $language: String!
  $id: String!
  $page: Int
  $quantity: Int
  $filters: [FactFinderNgFacetElementInput]
  $extraFilters: [FactFinderNgFacetElementInput]
  $supplier: String
  $publicAssortment: Boolean
) {
  searchProductsForFamilyNg(
    baseSiteId: $baseSiteId
    factFinderChannel: $factFinderChannel
    language: $language
    id: $id
    page: $page
    quantity: $quantity
    filters: $filters
    extraFilters: $extraFilters
    channel: ""
    supplier: $supplier
    publicAssortment: $publicAssortment
  ) {
    hits {
      variantValuesObject {
        ImageURL
        Slug
        Name
        ID
      }
    }
  }
}
